export class NodeLedger {
    public static RegisteredNodeNames: string[] = [];
    public static NameFormatter: (name: string) => string = (name: string) => name;
}
